/**
 * Prevents default so each autohandler does not have to implement it's own prevent default.
 */
var $ = require('js/sw-jquery/sw-jquery');

$(function() {
  $('body').on('click', '[data-sw-prevent-default]', function(e) {
    e.preventDefault();
  });
});
